<template>
  <div class="info_box">
    <!-- <div>{{tx_id}}</div> -->
    <div><img class="img_w" :src="room_data.cover" alt=""></div>
    <div class="main_box">
      <div class="mr1">{{room_data.title}}</div>
      <div class="mr2">{{time_format(room_data.update_time)}}</div>
      <div class="mr3">
        <span>{{$t('main.chef')}}</span>
        <span>
          <i class="el-icon-star-on xing"></i>
          {{$t('main.brand')}}
        </span>
      </div>
      <div class="des" v-if="room_data.location">
        <i class="el-icon-location-outline dt"></i>
        {{room_data.location}}
      </div>
      <div class="title">{{room_data.summary}}</div>
      <div class="des" v-html="room_data.content"></div>
      <div class="title" v-if="room_data.contact">{{$t('main.contact')}}</div>
      <div class="mr4" v-if="room_data.contact">
        <div class="mr4_lift">
          <div><img class="mr4_img2" src="../../assets/img/img2.png" alt=""></div>
          <div>
            <div class="mr4_1">{{room_data.contact}}</div>
            <div class="mr4_2">{{$t('main.manager')}}</div>
          </div>
        </div>
        <div v-if="room_data.phone_number">
          <img class="mr4_img3" @click="open_phone(room_data.phone_number)" src="../../assets/img/img3.png" alt="">
        </div>
      </div>
      <div class="title" v-if="room_data.type==3">{{$t('main.menu')}}</div>
      <div class="mr5" v-if="room_data.type==3">
        <div>{{room_data.menus_amount}} {{$t('main.course_menu')}}</div>
        <div>${{number_format2(room_data.menus_price)}} ++/{{$t('main.pax')}}</div>
      </div>
      <div class="title m_bottom5" v-if="room_data.type==3">{{$t('main.gallery')}}</div>
      <div v-if="room_data.type==3">
        <div v-for="(item,index) in room_data.menus" :key="index">
          <img class="img_w" :src="item">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { webDetails } from '@/api/api';

export default {
  data() {
    return {
      language:'',
      tx_id:'',
      room_data: {}
    };
  },
  beforeMount(){
      const queryString = window.location.search;
        if(queryString){
            // ?language=ch&tx_id=fa89db285cdf45de86e6441fac250a51
            const urlParams = new URLSearchParams(queryString);
            const lang = urlParams.get('language');
            const tx_id = urlParams.get('tx_id');
            if(lang&&tx_id){
                this.$i18n.locale = lang;
                this.language = lang;
                this.tx_id = tx_id;
            }
        }
  },
  mounted() {
    if(!this.language || !this.tx_id) return;
    this.get_list();
  },
  methods: {
    async get_list() {
      // 3 餐饮活动 有菜单和价格
      const res = await webDetails({
        tx_id:this.tx_id,
        language:this.language
      });
      if(res.data.code!=200){
        return this.$toast(res.data.msg);
      }
      this.room_data = res.data.data;
    },
    open_phone(phone){
      if(!phone) return false;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callPhone) {
          window.webkit.messageHandlers.callPhone.postMessage(phone);
        } else {
          console.error("window.webkit is not defined");
        }
      } else if (navigator.userAgent.match(/android/i)) {
        if (window.CASATask && typeof window.CASATask.callPhone === 'function') {
          window.CASATask.callPhone(phone);
        } else {
          console.error("CASATask interface is not available.");
        }
      }
    }
  },
};
</script>

<style scoped>
.info_box {
  min-height: 100vh;
  height: 100%;
  background: #FFFFFF;
  box-sizing: border-box;
  /* padding-bottom: 100px; */
}
.img_w{
  width: 100%;
}
.main_box{
  box-sizing: border-box;
  padding: 32px 16px;
}
.mr1{
  font-size: 16px;
  font-weight: bold;
}
.mr2{
  margin-top: 2px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.3)
}
.mr3{
  margin-top: 8px;
}
.mr3 span{
  height: 34px;
  line-height: 34px;
  font-size: 12px;
  padding: 0 20px;
  display: inline-block;
  background: #EEEEEE;
  border-radius: 10px;
}
.mr3 span:first-child{
  margin-right: 20px;
}
.xing{
  font-size: 18px;
  vertical-align: text-bottom;
}
.des{
  margin-top: 12px;
  color: #888;
  font-size: 10px;
}
.title{
  font-size: 16px;
  font-weight: bold;
  margin-top: 16px;
}
.mr4{
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mr4_img2{
  width: 35px;
  margin: 0 12px;
}
.mr4_1{
  font-size: 15px;
  font-weight: bold;
}
.mr4_2{
  color: #888;
  font-size: 10px;
}
.mr4_img3{
  width: 35px;
}
.mr4_lift{
  display: flex;
}
.mr4_img3:first-child{
  margin-right: 12px;
}
.mr5{
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 12px;
  height: 62px;
  background: #EEE;
  border-radius: 8px;
  font-size: 14px;
}
.mr5 div:last-child{
  font-size: 16px;
  font-weight: bold;
}
.m_bottom5{
  margin-bottom: 10px;
}

</style>
